import { Radio as BaseRadio } from '@base-ui/react/radio';
import { RadioGroup as BaseRadioGroup } from '@base-ui/react/radio-group';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type RadioGroupProps = ComponentProps<typeof BaseRadioGroup>;
export type RadioProps = ComponentProps<typeof BaseRadio.Root>;

/** The group owns the value; each {@link Radio} inside it owns one option. */
export function RadioGroup({ className, ...props }: RadioGroupProps) {
  return <BaseRadioGroup className={cx('flex flex-col gap-2', className)} {...props} />;
}

/** Circle + dot, as one component: the dot has no choices of its own. */
export function Radio({ className, ...props }: RadioProps) {
  return (
    <BaseRadio.Root
      className={cx(
        'flex size-4 shrink-0 items-center justify-center rounded-full',
        'border-2 border-ink-dim bg-surface-raised',
        'transition-[border-color] duration-150 ease-out-quint',
        'data-checked:border-brand-600',
        'data-invalid:border-danger',
        'data-disabled:cursor-not-allowed data-disabled:border-ink-faint',
        className,
      )}
      {...props}
    >
      {/* A filled dot inset from the ring, rather than a thick border: the
          border trick collapses the hit area as it grows. */}
      <BaseRadio.Indicator className="size-2.5 rounded-full bg-brand-600 data-unchecked:hidden" />
    </BaseRadio.Root>
  );
}
